/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { networkGetNetworkPingmyip } from "../../funcs/networkGetNetworkPingmyip.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$networkGetNetworkPingmyip: ToolDefinition = {
  name: "network-get-network-pingmyip",
  description: `Ping 我的 IP

这是一个非常方便的快捷接口，想知道你的网络到我们服务器的回程延迟吗？点一下就行！

## 功能概述
这个接口是 \`/network/myip\` 和 \`/network/ping\` 的结合体。它会自动获取你客户端的公网IP，然后从我们的服务器Ping这个IP，并返回延迟数据。这对于快速判断你本地网络到服务器的连接质量非常有用。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  tool: async (client, ctx) => {
    const [result] = await networkGetNetworkPingmyip(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
